module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/service-items/service-item-dialog/service-item-dialog.component.css
// module id = ./src/app/components/service-items/service-item-dialog/service-item-dialog.component.css
// module chunks = main